/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiaglabSampleItem } from 'app/shared/model/diaglab-sample-item.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { SampleStatusEvent } from 'app/shared/model/enumerations/sample-status-event.model';

export interface IDiaglabSampleItemStatus {
  id?: string;
  statusEvent?: keyof typeof SampleStatusEvent;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  eventDate?: number;
  diaglabSampleItem?: IDiaglabSampleItem;
  collector?: IDiaglabAssistant | null;
}

export const defaultValue: Readonly<IDiaglabSampleItemStatus> = {
  active: false,
};
